import { createContext, useContext } from 'react'

/**
 * True while an overlay that needs the customer's full attention is open on the menu, so tutorials
 * and education tooltips wait for it instead of competing with it.
 */
const TutorialsBlockedContext = createContext(false)
TutorialsBlockedContext.displayName = 'TutorialsBlockedContext'

export const TutorialsBlockedProvider = TutorialsBlockedContext.Provider
export const useAreTutorialsBlocked = (): boolean => useContext(TutorialsBlockedContext)
